import { combineReducers, configureStore } from "@reduxjs/toolkit";



import errorHadlingSlicer from "./Reducers/errorHadlingSlicer";
import dashboardSlicer from "./Reducers/dashboardSlicer";
import loginSlicer from "./Reducers/loginSlicer";
import derSlicer from "./Reducers/derSlicer";
import {
  persistStore,
  persistReducer,
  
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["der"], // Only these slices will be persisted
};

const rootReducer = combineReducers({
  login: loginSlicer,
  errorBoundry: errorHadlingSlicer,
  dashboard: dashboardSlicer,
  der: derSlicer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  // reducer: {

  //   login: loginSlicer,
  //   errorBoundry: errorHadlingSlicer,
  //   dashboard: dashboardSlicer,
  //   der: derSlicer,
  // },
  reducer: persistedReducer,
});

export const persistor = persistStore(store);
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
